import { render } from "./bootstraptabPage.vue?vue&type=template&id=643cc039"
import script from "./bootstraptabPage.vue?vue&type=script&lang=js"
export * from "./bootstraptabPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__